// extracted by mini-css-extract-plugin
module.exports = {"expandableTextArea":"Vendors_expandableTextArea__155s5"};